export const ROUTES = {
  ZENDESK: {
    PRE_TRADE_IN: 'zendesk-pre-trade-in',
    RESOLUTION_OPTIONS: 'zendesk-resolution-options',
    CUSTOMER_LIVE_CHAT: 'zendesk-customer-live-chat',
  },
}
